import { MENU_COLLAPSED_CHANGED, SIZE_CHANGED, CURRENT_ROUTE, APP_INFO, REHYDRATION_COMPLETE } from "redux/actions/appActions";

const initialState = {
  width: 1024,
  height: 768,
  collapsed: false,
  currentRoute: '/dashboard',
  rehydrated: true // Start as true since PersistGate handles initial loading
};

export const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case SIZE_CHANGED:
      return {
        ...state,
        ...action.payload
      }
    case MENU_COLLAPSED_CHANGED:
      return {
        ...state,
        ...action.payload
      }
    case CURRENT_ROUTE:
      return {
        ...state,
        ...action.payload
      }
    case APP_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case REHYDRATION_COMPLETE:
      return {
        ...state,
        rehydrated: true
      };
    case 'persist/REHYDRATE':
      // Redux-persist dispatches this action when rehydration completes
      return {
        ...state,
        rehydrated: true
      };
    default:
      return state;
  }
};
